import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import { UserStoreProvider } from "./contexts/UserStoreContext";
import NotFound from "pages/NotFound";
import PricingPlans from './pages/pricing-plans';
import ContactSales from './pages/contact-sales';
import ApiDocumentation from './pages/api-documentation';
import LandingPage from './pages/landing-page';
import DeveloperPortal from './pages/developer-portal';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import ProtectedRoute from './components/ProtectedRoute';
import Success from './pages/payment/Success';
import Cancel from './pages/payment/Cancel';
import InvoicesList from './pages/invoices/InvoicesList';
import InvoiceDetails from './pages/invoices/InvoiceDetails';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <UserStoreProvider>
            <ScrollToTop />
            <RouterRoutes>
              {/* Define your route here */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/pricing-plans" element={<PricingPlans />} />
              <Route path="/contact-sales" element={<ContactSales />} />
              <Route path="/api-documentation" element={<ApiDocumentation />} />
              <Route path="/landing-page" element={<LandingPage />} />
              <Route path="/developer-portal" element={<ProtectedRoute><DeveloperPortal /></ProtectedRoute>} />

              {/* Authentication Routes */}
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/signup" element={<Signup />} />

              {/* Payment Routes */}
              <Route path="/payment/success" element={<ProtectedRoute><Success /></ProtectedRoute>} />
              <Route path="/payment/cancel" element={<ProtectedRoute><Cancel /></ProtectedRoute>} />

              {/* Invoice Routes */}
              <Route path="/invoices" element={<ProtectedRoute><InvoicesList /></ProtectedRoute>} />
              <Route path="/invoices/:id" element={<ProtectedRoute><InvoiceDetails /></ProtectedRoute>} />

              <Route path="*" element={<NotFound />} />
            </RouterRoutes>
          </UserStoreProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;